import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from 'lodash';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DateRangePicker, DateRangeDelimiter, TimePicker, DateTimePicker } from "@material-ui/pickers";
import {
  withStyles,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import * as Var from "styles/variables";
import {
  setDateRangePicTree,
  getHomePictreeCheckInNtt,
  getHomePictreePhotoShootNtt,
  getPictreeDataCheckInTrendNtt,
  getPictreeDataPhotoShootTrendNtt,
  getPictreeDataPhotoDenchuKaisuTrend,
  getInGameItemSalesByOccurrence,
  getPhotoShootMapDataNtt,
  getPictreePhotoShootByAssetNtt,
  getPictreePhotoShootTrendByAssetNtt,
  getPointOverviewDataPicTree,
  getPointTrendDataPicTree,
  getRewardCoinSummary,
  getRewardCoinRankingData,
  getRewardedCoinData,
  getPhotoShootRankingData,
  getPhotoFirstShootRankingData,
  getSeasonRankingData,
  getAreaRankingData,
  setTimeRangePicTree,
  getPicTreeGoldChestTrend,
  getPicTreeRainbowListDetail,
} from "actions";
import PeriodAll from "components/PicTree/Filter/PeriodAll";

const useStyles = makeStyles((theme) =>
  createStyles({
    calendarWrapper: {
      paddingLeft: 8,
      flexGrow: 1,
    },
    root: {
      backgroundColor: "#fafafa",
      zIndex: 1000,
      paddingTop: 16,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      maxWidth: 600,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      color: Var.btnLabelColor,
    },
    grow: {
      flexGrow: 1,
    },
    sectionCalendar: {
      display: "flex",
      marginRight: theme.spacing(1),
    },
    picTreePredefined: {
      marginRight: theme.spacing(2),
    },
    dateField: {
      width: 120,
      marginLeft: theme.spacing(1),
    },
    timeField: {
      width: 120,
      marginLeft: theme.spacing(1),
    },
  })
);

const CalendarRangePickerAll = ({
  page,
  dateRangePicTree,
  dateRangePicTreeMinMax,
  currentPage,
  setDateRangePicTree,
  getPointOverviewDataPicTree,
  getPointTrendDataPicTree,
  getRewardCoinSummary,
  getRewardCoinRankingData,
  getRewardedCoinData,
  getPhotoShootRankingData,
  getPhotoFirstShootRankingData,
  getSeasonRankingData,
  getAreaRankingData,
  setTimeRangePicTree,
  timeselect = false,
  singleSelect = false,
  timeRangePicTree,
  getPicTreeGoldChestTrend,
  getPicTreeRainbowListDetail,
}) => {
  const classes = useStyles();
  const [dateRangeValue, setDateRangeValue] = useState([null, null]);
  const [error, setError] = useState([null, null]);
  const [minDate, setMinDate] = useState(moment("2024-12-07").tz("Asia/Tokyo").format("YYYY/MM/DD"));
  const [maxDate, setMaxDate] = useState(moment("2025-01-12").tz("Asia/Tokyo").format("YYYY/MM/DD"));
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("18:00");

  const today = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
  const todayFormatted = moment(today).format("YYYY-MM-DD");

  useEffect(() => {
    const currentJstDate = moment().tz("Asia/Tokyo").format("YYYY/MM/DD");
    handleHomeCalendar(currentJstDate);
  }, []);

  useEffect(() => {
    setTimeRangePicTree([startTime, endTime]);
  }, [startTime, endTime]);

  useEffect(() => {
    if (dateRangePicTreeMinMax.length > 0) {
      const defaultMaxDateFormatted = moment(dateRangePicTreeMinMax[1]).format('YYYY-MM-DD');
      const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
      setMinDate(dateRangePicTreeMinMax[0]);
      setMaxDate(isEndDateAfterToday ? todayFormatted : dateRangePicTreeMinMax[1]);
    }
  }, [dateRangePicTreeMinMax]);

  useEffect(() => {
    const defaultMaxDateFormatted = moment(dateRangePicTreeMinMax[1]).format('YYYY-MM-DD');
    const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
    const dateRangeValue = isEndDateAfterToday ? [dateRangePicTree[0], todayFormatted] : dateRangePicTree;
    setDateRangeValue(dateRangeValue);
  }, [dateRangePicTree]);

  const handleHomeCalendar = (currentJstDate) => {
    setDateRangeValue(dateRangePicTree);
  };

  const setRange = (newValue) => {
    const startDate = moment(newValue[0]).format("YYYY-MM-DD");
    const endDate = moment(newValue[1]).format("YYYY-MM-DD");
    setDateRangePicTree([startDate, endDate]);
    setDateRangeValue([startDate, endDate]);
  };

  const fetchData = () => {
    if (currentPage === "/game/pictree/all/point") {
      getPointOverviewDataPicTree();
      getPointTrendDataPicTree();
    } else if (currentPage === "/game/pictree/all/reward-coin/ranking") {
      getRewardCoinSummary();
      getRewardCoinRankingData();
    } else if (currentPage === "/game/pictree/all/reward-coin/count-by-coin") {
      getRewardedCoinData();
    } else if (currentPage === "/game/pictree/all/ranking/photo-ranking") {
      getPhotoShootRankingData();
    } else if (currentPage === "/game/pictree/all/ranking/first-photo-ranking") {
      getPhotoFirstShootRankingData();
    } else if (currentPage === "/game/pictree/all/ranking/season-ranking") {
      getSeasonRankingData();
    } else if (currentPage === "/game/pictree/all/ranking/area-ranking") {
      getAreaRankingData();
    } else if (currentPage === "/game/pictree/all/treasure-chest/daily-count") {
      getPicTreeGoldChestTrend();
    } else if (currentPage === "/game/pictree/all/treasure-chest/rainbow-list") {
      getPicTreeRainbowListDetail();
    }
  };

  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.root}>
        <div className={classes.sectionCalendar}>
          <div className={classes.picTreePredefined}>
            <PeriodAll
              singelSelect={singleSelect}
              timeselect={timeselect}
            />
          </div>
          <DateRangePicker
            startText="Start"
            endText="End"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            minDate={minDate}
            maxDate={maxDate}
            value={dateRangeValue}
            onChange={(newValue) => setRange(newValue)}
            onError={([startReason, endReason], [start, end]) => {
              if (startReason === "invalidRange") {
                setError([null, null]);
                return;
              }
              setError([startReason, endReason]);
            }}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField
                  id="standard-basic"
                  {...startProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                  className={classes.dateField}
                />
                {timeselect &&
                <TextField
                  id="start-time"
                  type="time"
                  value={timeRangePicTree[0]}
                  className={classes.timeField}
                  onChange={(e) => setStartTime(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5分刻み
                  }}
                />
                }
                <DateRangeDelimiter>
                  <span className={classes.delimiter}>~</span>
                </DateRangeDelimiter>
                <TextField
                  id="standard-basic"
                  {...endProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                  className={classes.dateField}
                />
                {timeselect &&
                <TextField
                  id="end-time"
                  type="time"
                  value={timeRangePicTree[1]}
                  className={classes.timeField}
                  onChange={(e) => setEndTime(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5分刻み
                  }}
                />
                }
              </div>
            )}
          />
          <Button
            className={classes.dataBtn}
            variant="contained"
            color="primary"
            onClick={() => fetchData()}
          >
            GO
          </Button>
        </div>
      </div>
    </div>
  );
};

CalendarRangePickerAll.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  btnStateDataFetch: state.page.btnStateDataFetch,
  dateRangePicTree: state.page.dateRangePicTree,
  timeRangePicTree: state.page.timeRangePicTree,
  dateRangePicTreeMinMax: state.page.dateRangePicTreeMinMax,
  currentPage: state.page.currentPage,
  pictreeView: state.pictree.pictreeView,
  pictreeChartSize: state.pictree.chartSize,
  pictreeMapType: state.pictree.mapType,
});

const mapDispatchToProps = (dispatch) => ({
  setDateRangePicTree: (param) => dispatch(setDateRangePicTree(param)),
  getHomePictreeCheckInNtt: (param) => dispatch(getHomePictreeCheckInNtt(param)),
  getHomePictreePhotoShootNtt: (param) => dispatch(getHomePictreePhotoShootNtt(param)),
  getPictreeDataCheckInTrendNtt: (param) => dispatch(getPictreeDataCheckInTrendNtt(param)),
  getPictreeDataPhotoShootTrendNtt: (param) => dispatch(getPictreeDataPhotoShootTrendNtt(param)),
  getPictreeDataPhotoDenchuKaisuTrend: (param) => dispatch(getPictreeDataPhotoDenchuKaisuTrend(param)),
  getInGameItemSalesByOccurrence: (param) => dispatch(getInGameItemSalesByOccurrence(param)),
  getPhotoShootMapDataNtt: (param) => dispatch(getPhotoShootMapDataNtt(param)),
  getPictreePhotoShootByAssetNtt: (param) => dispatch(getPictreePhotoShootByAssetNtt(param)),
  getPictreePhotoShootTrendByAssetNtt: (param) => dispatch(getPictreePhotoShootTrendByAssetNtt(param)),
  getPointOverviewDataPicTree: (param) => dispatch(getPointOverviewDataPicTree(param)),
  getPointTrendDataPicTree: (param) => dispatch(getPointTrendDataPicTree(param)),
  getRewardCoinSummary: (param) => dispatch(getRewardCoinSummary(param)),
  getRewardCoinRankingData: (param) => dispatch(getRewardCoinRankingData(param)),
  getPhotoShootRankingData: (param) => dispatch(getPhotoShootRankingData(param)),
  getPhotoFirstShootRankingData: (param) => dispatch(getPhotoFirstShootRankingData(param)),
  getSeasonRankingData: (param) => dispatch(getSeasonRankingData(param)),
  getAreaRankingData: (param) => dispatch(getAreaRankingData(param)),
  setTimeRangePicTree: (param) => dispatch(setTimeRangePicTree(param)),
  getPicTreeGoldChestTrend: (param) => dispatch(getPicTreeGoldChestTrend(param)),
  getRewardedCoinData: (param) => dispatch(getRewardedCoinData(param)),
  getPicTreeRainbowListDetail: (param) => dispatch(getPicTreeRainbowListDetail(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(CalendarRangePickerAll));
